import React from 'react';
import { useQuery } from 'react-query';
import { Get } from '../../../../utils/httpProvider';
import { ACCOUNT_AUTHINFO_API } from '../../../../utils/apiUrl';

/**
 * Component chuyên biệt hiển thị thông tin Học viên trong danh sách CME
 * Lấy trực tiếp từ API Account/GetItem của cổng 5003 để có đủ Username (CCCD) và AuthInfo
 */
const CMEParticipantCell = ({ userId, mode }) => {
    const { data: accountInfo, isLoading } = useQuery(
        ['accountInfo', userId],
        () => Get(ACCOUNT_AUTHINFO_API.GET_BY_ID_ACCOUNT, userId),
        {
            enabled: !!userId,
            staleTime: 600000,
            cacheTime: 900000,
        }
    );

    if (!userId) return <span className="text-muted">N/A</span>;
    
    if (isLoading) {
        return (
            <div className="d-flex align-items-center">
                <div className="spinner-border spinner-border-sm text-primary mr-2" role="status"></div>
                <small className="text-muted" style={{ fontSize: '0.8rem' }}>...</small>
            </div>
        );
    }

    const uName = accountInfo?.account?.username || accountInfo?.account?.Username || accountInfo?.username || accountInfo?.Username || accountInfo?.identityCardNumber || accountInfo?.IdentityCardNumber || accountInfo?.accountAuthInfo?.identityCardNumber || accountInfo?.AccountAuthInfo?.IdentityCardNumber;
    // AccountAuthInfo/GetItem trả về fields trực tiếp, Account/GetItem trả về nested trong accountAuthInfo
    const authInfo = accountInfo?.accountAuthInfo || accountInfo?.AccountAuthInfo || accountInfo;

    const fullName = [
        authInfo?.lastName || authInfo?.LastName,
        authInfo?.middleName || authInfo?.MiddleName,
        authInfo?.firstName || authInfo?.FirstName
    ].filter(Boolean).join(' ') || 'Chưa cập nhật';

    if (mode === 'username') return <span className="font-weight-bold text-dark" style={{ fontSize: '0.9rem' }}>{uName || 'N/A'}</span>;
    if (mode === 'name') return <span className="font-weight-bold text-dark" style={{ fontSize: '0.9rem' }}>{fullName}</span>;

    return (
        <div className="d-flex flex-column">
            <span className="font-weight-bold text-dark" style={{ fontSize: '0.9rem' }}>{fullName}</span>
            {uName && <small className="text-muted" style={{ fontSize: '0.75rem' }}>{uName}</small>}
        </div>
    );
};

export default CMEParticipantCell;
